<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                Assegna Prodotti
                <v-spacer></v-spacer>
                <v-file-input
                    ref="csvFileInput"
                    v-model="csvFile"
                    accept=".csv"
                    label="Import EAN"
                    prepend-icon="mdi-upload"
                    @change="importEanFromCsv"
                    hide-details
                    style="display: none"
                ></v-file-input>
                <v-btn
                    color="primary"
                    @click="$refs.csvFileInput.$refs.input.click()"
                    :loading="importLoading"
                    small
                >
                    <v-icon left>mdi-upload</v-icon>
                    Import EAN
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-list v-if="selectedProducts">
                            <v-list-item
                                v-for="product in selectedProducts"
                                :key="product.id"
                            >
                                <v-list-item-action>
                                    <v-btn icon @click="moveProductUp(product)">
                                        <v-icon small>mdi-arrow-up</v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        @click="moveProductDown(product)"
                                    >
                                        <v-icon small>mdi-arrow-down</v-icon>
                                    </v-btn>
                                </v-list-item-action>

                                <v-list-item-avatar :rounded="false">
                                    <v-img
                                        @mousemove="moveOverlay($event, 'left')"
                                        @mouseover="enlargeImage(product)"
                                        @mouseleave="hideOverlay"
                                        :src="getProductImage(product)"
                                    ></v-img>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ product.ar_codart }} -
                                        <b>{{ product.ar_descr }}</b> ({{
                                            product.bc_code
                                        }})
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        {{ product.ar_codforn }} -
                                        {{ product.an_descr1 }} | Giac.:
                                        {{ product.xx_dissede }}
                                    </v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-action>
                                    <v-btn
                                        fab
                                        small
                                        depressed
                                        color="error"
                                        @click="
                                            removeFromSelectedProduct(product)
                                        "
                                    >
                                        <v-icon> mdi-minus </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col>
                        <v-card>
                            <v-card-text>
                                <div v-if="!loaderProduct">
                                    <v-row>
                                        <v-col class="text-right">
                                            <v-text-field
                                                label="Cerca Prodotto"
                                                v-model="searchProduct"
                                                prepend-icon="mdi-magnify"
                                                @input="filterProduct"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-select
                                                :items="orderOptions"
                                                v-model="selectedOrder"
                                                label="Ordina"
                                                @change="filterProduct"
                                            ></v-select>
                                        </v-col>
                                        <v-col cols="auto">
                                            <v-checkbox
                                                v-model="showOnlyImportedEan"
                                                label="Solo EAN importati"
                                                @change="filterProduct"
                                                hide-details
                                            ></v-checkbox>
                                        </v-col>
                                    </v-row>
                                    <v-virtual-scroll
                                        :items="productList"
                                        height="490"
                                        item-height="64"
                                        bench="10"
                                    >
                                        <template v-slot:default="{ item }">
                                            <v-list-item :key="item.id">
                                                <v-list-item-action>
                                                    <v-btn
                                                        fab
                                                        small
                                                        depressed
                                                        color="primary"
                                                        :disabled="
                                                            checkIfAlreadySelected(
                                                                item
                                                            )
                                                        "
                                                        @click="
                                                            addToSelectedProduct(
                                                                item
                                                            )
                                                        "
                                                    >
                                                        <v-icon>
                                                            mdi-plus
                                                        </v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.ar_codart }} -
                                                        <b>{{
                                                            item.ar_descr
                                                        }}</b>
                                                        ({{ item.bc_code }})
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle>
                                                    </v-list-item-subtitle>
                                                    <v-list-item-subtitle>
                                                        {{ item.ar_codforn }} -
                                                        {{ item.an_descr1 }} |
                                                        Giac.:
                                                        {{ item.xx_dissede }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-avatar
                                                    :rounded="false"
                                                >
                                                    <v-img
                                                        @mousemove="
                                                            moveOverlay(
                                                                $event,
                                                                'right'
                                                            )
                                                        "
                                                        @mouseover="
                                                            enlargeImage(item)
                                                        "
                                                        @mouseleave="
                                                            hideOverlay
                                                        "
                                                        :src="
                                                            getProductImage(
                                                                item
                                                            )
                                                        "
                                                    ></v-img>
                                                </v-list-item-avatar>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                        </template>
                                    </v-virtual-scroll>
                                </div>
                                <div
                                    v-else
                                    class="text-center align-center pa-4"
                                >
                                    <v-progress-circular
                                        :size="50"
                                        color="primary"
                                        indeterminate
                                        class="align-center"
                                    ></v-progress-circular>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col> </v-row
            ></v-card-text>
        </v-card>
        <div v-if="overlayImage" class="overlay" :style="overlayStyles">
            <img
                :src="overlayImage"
                alt="Immagine ingrandita"
                class="overlay-image"
            />
        </div>
    </v-container>
</template>
<script>
import helpers from "../../../helpers";
import requests from "../../../requests";

let OriginalProductList = [];

export default {
    name: "ProducClustertList",

    mounted() {
        console.log("ProductClusterList Mounted.");
        this.getProductList();
    },

    props: {
        familiesIds: {
            type: Array,
            default: [],
        },
        subFamiliesIds: {
            type: Array,
            default: [],
        },
        selectedProducts: {
            type: Array,
            default: [],
        },
        opened: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        opened(newVal) {
            if (newVal) this.getProductList();
        },
    },

    data() {
        return {
            productList: [],
            //selectedProducts: [],
            loaderProduct: false,
            searchProduct: "",
            orderOptions: ["ASC", "DESC"],
            selectedOrder: "ASC",
            csvFile: null,
            importLoading: false,
            importedEanProducts: [],
            showOnlyImportedEan: false,
            overlayImage: null,
            overlayStyles: {
                position: "absolute",
                top: "0px",
                left: "0px",
                pointerEvents: "none", // Importante per non “bloccare” gli eventi mouse
                transform: "translate(-50%, -50%)", // Per centrare l'immagine rispetto al cursore
            },
        };
    },

    methods: {
        filterProductList() {
            /* let tmpFilters = _.filter(OriginalProductList, (o) => {
                if (_.isNull(o.acl_idla2)) return false;
                return this.subFamiliesIds.includes(parseInt(o.acl_idla2));
            }); */
            let tmpFilters = this.showOnlyImportedEan
                ? this.importedEanProducts
                : OriginalProductList;
            if (this.searchProduct) {
                tmpFilters = _.filter(tmpFilters, (o) => {
                    return (
                        _.lowerCase(o.ar_descr).includes(
                            _.lowerCase(this.searchProduct)
                        ) ||
                        _.lowerCase(o.ar_codart).includes(
                            _.lowerCase(this.searchProduct)
                        ) ||
                        _.lowerCase(o.bc_code).includes(
                            _.lowerCase(this.searchProduct)
                        ) ||
                        _.lowerCase(o.ar_codforn).includes(
                            _.lowerCase(this.searchProduct)
                        ) ||
                        _.lowerCase(o.an_descr1).includes(
                            _.lowerCase(this.searchProduct)
                        )
                    );
                });
            }

            tmpFilters = _.orderBy(
                tmpFilters,
                ["xx_dissede"],
                [_.lowerCase(this.selectedOrder)]
            );
            tmpFilters = _.values(tmpFilters);
            return tmpFilters;
        },
        filterProduct() {
            console.log(this.selectedOrder);
            this.productList = this.filterProductList();
        },

        getProductList() {
            let filters = {
                direction: "asc",
                inFam: this.familiesIds,
                inSubFam: this.subFamiliesIds,
            };
            this.loaderProduct = true;
            requests.searchProduct(filters).then((response) => {
                OriginalProductList = response.data;
                this.productList = this.filterProductList();
                this.loaderProduct = false;
            });
        },
        addToSelectedProduct(item) {
            this.selectedProducts.push(item);
            this.$emit("selectedChange", this.selectedProducts);
        },
        removeFromSelectedProduct(item) {
            this.selectedProducts.splice(
                _.findIndex(this.selectedProducts, { id: item.id }),
                1
            );
            this.$emit("selectedChange", this.selectedProducts);
        },
        getProductImage(item) {
            return helpers.getImagePath(item.ar_codart);
        },
        checkIfAlreadySelected(item) {
            return _.findIndex(this.selectedProducts, { id: item.id }) > -1;
        },

        enlargeImage(product) {
            this.overlayImage = this.getProductImage(product);
        },
        hideOverlay() {
            this.overlayImage = null;
        },
        moveOverlay(e, position) {
            // Ottieni la posizione del contenitore
            const containerRect = e.currentTarget.getBoundingClientRect();

            // Calcola la posizione del mouse relativa al contenitore
            const mouseX = containerRect.left;
            const mouseY = containerRect.top;

            // Applica un piccolo offset dal cursore, se lo desideri
            let offsetY = 0;
            let offsetX = 0;
            if (position == "left") {
                offsetY = 0;
                offsetX = 150;
            } else if (position == "right") {
                offsetY = 0;
                offsetX = -150;
            }
            this.overlayStyles.top = mouseY + offsetY + "px";
            this.overlayStyles.left = mouseX + offsetX + "px";
        },
        moveProductUp(product) {
            let index = _.findIndex(this.selectedProducts, { id: product.id });
            if (index > 0) {
                let tmp = this.selectedProducts[index];
                this.selectedProducts[index] = this.selectedProducts[index - 1];
                this.selectedProducts[index - 1] = tmp;
                this.$forceUpdate();
            }
        },
        moveProductDown(product) {
            let index = _.findIndex(this.selectedProducts, { id: product.id });
            if (index < this.selectedProducts.length - 1) {
                let tmp = this.selectedProducts[index];
                this.selectedProducts[index] = this.selectedProducts[index + 1];
                this.selectedProducts[index + 1] = tmp;
                this.$forceUpdate();
            }
        },

        async importEanFromCsv() {
            if (!this.csvFile) return;

            this.importLoading = true;

            try {
                const formData = new FormData();
                formData.append("csv_file", this.csvFile);

                const response = await axios.post(
                    "/api/products/lookup-csv",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (
                    response.data.products &&
                    response.data.products.length > 0
                ) {
                    // Store imported products in separate variable
                    this.importedEanProducts = response.data.products;

                    // Auto select the checkbox to show imported products
                    this.showOnlyImportedEan = true;
                    this.filterProduct();

                    // Optionally add to selected products (uncomment if needed)
                    // response.data.products.forEach((product) => {
                    //     if (!this.checkIfAlreadySelected(product)) {
                    //         this.selectedProducts.push(product);
                    //     }
                    // });
                    // this.$emit("selectedChange", this.selectedProducts);

                    // Show success message
                    this.$toast.success(
                        `Importati ${response.data.found_count} prodotti di ${response.data.requested_count} richiesti`
                    );

                    // Show missing EAN codes if any
                    if (response.data.missing_ean_codes.length > 0) {
                        this.$toast.warning(
                            `EAN non trovati: ${response.data.missing_ean_codes.join(
                                ", "
                            )}`
                        );
                    }
                } else {
                    this.$toast.warning("Nessun prodotto trovato nel file CSV");
                }
            } catch (error) {
                console.error("Errore durante l'importazione:", error);
                this.$toast.error("Errore durante l'importazione del file CSV");
            } finally {
                this.importLoading = false;
                this.csvFile = null;
            }
        },
    },
};
</script>
<style scoped>
.image-container {
    position: relative;
    width: 300px; /* Larghezza del contenitore */
    height: 200px; /* Altezza del contenitore */
}

.thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* Overlay assoluto, segue la posizione impostata in overlayStyles */
.overlay {
    position: absolute;
    pointer-events: none; /* Ribadito anche qui, evita conflitti di puntatore */
}

/* Stile dell’immagine in overlay (ingrandita) */
.overlay-image {
    max-width: 300px;
    max-height: 3000px;
    border: 2px solid #fff;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}
</style>
